import { CategoryChoiceValue } from '@scale/shared/types/params/textcollection';

export const includesValueTrimmingSpaces = (
  response: CategoryChoiceValue[],
  choiceValue: string | number | boolean,
) => {
  if (typeof choiceValue === 'string') {
    return response.includes(choiceValue) || response.includes(choiceValue.trim());
  }
  return response.includes(choiceValue);
};
